import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogContent, DialogActions, Button, Typography, Box, Stepper, Step, StepLabel,
  Card, CardContent, useTheme, MobileStepper
} from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';

const steps = [
    {
        label: 'Welcome to BrightSparc',
        description: 'Your journey to funding starts here. This dashboard is your command center for tracking applications.',
        icon: <img src="/logo192.png" alt="BrightSparc" style={{ height: 60, marginBottom: 16 }} onError={(e) => e.target.style.display='none'} /> 
    },
    {
        label: 'Step 1: Complete Your Profile',
        description: 'Before you apply, go to your Profile page. We use your details to auto-fill every application form, saving you hours of typing.',
        icon: <AccountCircleIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
    },
    {
        label: 'Step 2: Digital Vault',
        description: 'Upload your ID, transcripts, and certificates once in "My Documents". You can then attach them to any bursary application with a single click.',
        icon: <DescriptionIcon sx={{ fontSize: 60, color: 'secondary.main', mb: 2 }} />
    },
    {
        label: 'Step 3: Find & Apply',
        description: 'Visit the Home Page to browse active bursaries. Use filters to find funds that match your field of study.',
        icon: <SearchIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
    }
];

const WelcomeOnboarding = ({ open, onClose }) => {
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = steps.length;

    const handleNext = () => {
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handleFinish = () => {
        // Save to local storage so it doesn't show again
        localStorage.setItem('hasSeenOnboarding', 'true');
        onClose();
    };

    if (!open) return null;

    return (
        <Dialog 
            open={open} 
            onClose={handleFinish} // Closing via backdrop also finishes it
            maxWidth="xs" 
            fullWidth
            PaperProps={{
                sx: { borderRadius: 3, p: 1 }
            }}
        >
            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                <Box sx={{ minHeight: 180, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {steps[activeStep].icon}
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        {steps[activeStep].label}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        {steps[activeStep].description}
                    </Typography>
                </Box>
            </DialogContent>
            
            <MobileStepper
                variant="dots"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                sx={{ bgcolor: 'transparent', mb: 1 }}
                nextButton={
                    <Button size="small" onClick={activeStep === maxSteps - 1 ? handleFinish : handleNext} variant={activeStep === maxSteps - 1 ? "contained" : "text"}>
                        {activeStep === maxSteps - 1 ? 'Get Started' : 'Next'}
                        {activeStep !== maxSteps - 1 && <KeyboardArrowRight />}
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        <KeyboardArrowLeft />
                        Back
                    </Button>
                }
            />
        </Dialog>
    );
};

export default WelcomeOnboarding;